export enum HeaderEvents {
  HEADER_ICON_CHANGE_EVENT = 'owc-header-icon-change',
  FLYOUT_CLOSE_EVENT = 'owc-header-flyout-close',
  MAIN_FLYOUT_CLOSE_EVENT = 'owc-header-main-flyout-close',
  FLYOUT_VISIBILITY_CHANGE = 'owc-header-flyout-visibility-change',
  FSS_INPUT_FOCUS_CHANGE = 'fssOnInputFocusChange', // event specified by FSS team, hence the lack of consistency
  REQUEST_FLYOUT_OPEN = 'owc-header-request-flyout-open',
  FLYOUT_BLOCK_CLOSE = 'owc-header-block-flyout-close',
}
